// extracted by mini-css-extract-plugin
export default {"wrapper":"payslips_wrapper__5aaGS"};